export default "__VITE_ASSET__aTVu3h3s__"